function defineCssRule(pName, pRule) {
  // Note: from http://stackoverflow.com/questions/1720320/how-to-dynamically-create-css-class-in-javascript-and-apply
  let lS = document.getElementById('assembler_style');
  if(undefined == lS) {
    lS = document.createElement('style');
    lS.type = 'text/css';
    lS.id = 'assembler_style';
    document.head.appendChild(lS);
  }
  /* eslint no-debugger: 0 */

  if ('string' == typeof pRule) {
    lS.sheet.insertRule(pName + " {" + pRule + "}", 0);
  } else {
    // just to give the ability to do _define('.test', { border: '1px red solid', border-radius: '1px' })
    pRule && lS.sheet.insertRule(pName + ' ' + JSON.stringify(pRule).replace(/",/ig, ';').replace(/"/ig, ''), 0);
  }
}


export {
  defineCssRule
};
